import { cn } from "@/lib/utils";

interface TimelineStep {
  year?: string;
  label?: string;
  title: string;
  description: string;
}

interface TimelineProps {
  steps: TimelineStep[];
  variant?: "light" | "dark";
}

const Timeline = ({ steps, variant = "light" }: TimelineProps) => {
  const isDark = variant === "dark";

  return (
    <div className="relative py-4">
      {/* Vertical line */}
      <div
        className={cn(
          "absolute left-4 md:left-1/2 top-0 bottom-0 w-px md:-translate-x-px",
          isDark ? "bg-foreground/20" : "bg-border"
        )}
      />

      <div className="space-y-16 md:space-y-20">
        {steps.map((step, i) => {
          const isLeft = i % 2 === 0;
          return (
            <div key={i} className="relative flex items-start md:items-center">
              {/* Dot */}
              <div
                className={cn(
                  "absolute left-4 md:left-1/2 w-4 h-4 rounded-full border-[3px] -translate-x-2 mt-1 md:mt-0 z-10",
                  isDark
                    ? "bg-accent border-secondary"
                    : "bg-accent border-background"
                )}
              />

              {/* Content */}
              <div
                className={cn(
                  "ml-14 md:ml-0 md:w-[calc(50%-3rem)]",
                  isLeft ? "md:pr-8 md:text-right" : "md:pl-8 md:ml-auto"
                )}
              >
                {(step.year || step.label) && (
                  <span className="font-body text-xs uppercase tracking-[0.14em] text-accent mb-2 block font-semibold">
                    {step.year || step.label}
                  </span>
                )}
                <h4
                  className={cn(
                    "font-headline text-xl md:text-2xl mb-2",
                    "text-foreground"
                  )}
                >
                  {step.title}
                </h4>
                <p
                  className={cn(
                    "text-base leading-relaxed",
                    "text-muted-foreground"
                  )}
                >
                  {step.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Timeline;
